import SVGInjector from "svg-injector";

$(function () {

	SVGInjector(document.querySelectorAll(".inject-svg"), {}, function (totalSVGsInjected) {
		var animationTimeout = null;
		var $maskPath = $('#dynamic-mask-path');
		var $zoomLayer = $('#zoom-layer'); // Layer chứa cả IMG và SVG

		var $btns = $('.location-btn');
		var totalBtns = $btns.length;
		var currentAutoIndex = 0;
		var loopInterval = null;
		var loopResumeTimeout = null;
		var LOOP_DELAY = 5000; // Tăng delay lên một chút để kịp xem zoom

		$(".pinpoint").each(function () {
			const ref = $(this)
			const id = ref.attr('id').replace('#', '')
			const tooltip = $(`.location-tooltip-wrapper[data-index="${id}"]`).html();


			if (tooltip) {
				tippy(ref[0], {
					content: tooltip,
					allowHTML: true,
					arrow: true,
					placement: "top",
					theme: "location-tooltip-theme",
					interactive: true,
					trigger: 'mouseenter click',
					hideOnClick: false,
					// FIX 1: Dùng strategy fixed để tính toán vị trí chính xác hơn khi có scale
					popperOptions: {
						strategy: 'fixed',
						modifiers: [
							{
								name: 'computeStyles',
								options: {
									adaptive: false,
								},
							},
						],
					},
					offset: [-10, 0],
					interactiveBorder: 5,
					appendTo: () => document.body,
				});
			}
		});

		function startLoop() {
			if (loopInterval) clearInterval(loopInterval);
			loopInterval = setInterval(function () {
				currentAutoIndex = (currentAutoIndex + 1) % totalBtns;
				$btns.eq(currentAutoIndex).trigger('click', [true]);
			}, LOOP_DELAY);
		}

		function stopLoop() {
			if (loopInterval) clearInterval(loopInterval);
			if (loopResumeTimeout) clearTimeout(loopResumeTimeout);
		}

		function applyZoom($targetGroup, shouldZoom) {
			if (!shouldZoom) {
				$zoomLayer.css('transform', 'translate(0, 0) scale(1)');
				return;
			}

			var viewportW = $('.map-viewport').width();
			var viewportH = $('.map-viewport').height();
			var bbox = $targetGroup[0].querySelector('.dot').getBBox();
			var svgCenterX = bbox.x + bbox.width / 2;
			var svgCenterY = bbox.y + bbox.height / 2;

			var scaleX = viewportW / 1920;
			var scaleY = viewportH / 960;
			var coverScale = Math.max(scaleX, scaleY);

			var renderedW = 1920 * coverScale;
			var renderedH = 960 * coverScale;
			var offsetX = (viewportW - renderedW) / 2;
			var offsetY = (viewportH - renderedH) / 2;

			var pixelCenterX = svgCenterX * coverScale + offsetX;
			var pixelCenterY = svgCenterY * coverScale + offsetY;

			var zoomLevel = $(window).width() < 1024.96 ? 0.95 : 1.35; // Độ zoom (có thể tùy chỉnh)

			if ($(window).width() > 1024.96) {
				viewportW = viewportW / 2;
				viewportH = viewportH / 2;
			}
			var translateX = zoomLevel * (viewportW - pixelCenterX);
			var translateY = zoomLevel * (viewportH - pixelCenterY);

			$zoomLayer.css('transform',
				'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + zoomLevel + ')'
			);
		}

		$('.location-btn').on('click', function (e, isAuto) {
			var $this = $(this);

			if (isAuto) {
				// Auto logic
			} else {
				stopLoop();
				currentAutoIndex = $btns.index($this);
				loopResumeTimeout = setTimeout(function () {
					currentAutoIndex = (currentAutoIndex + 1) % totalBtns;
					$btns.eq(currentAutoIndex).trigger('click', [true]);
					startLoop();
				}, LOOP_DELAY);
			}

			var routeId = $this.data('target');
			var isZoom = $(window).width() < 1024.96 ? false : $this.data('zoom'); // Đọc thuộc tính data-zoom

			$('.location-btn').removeClass('active');
			$this.addClass('active');

			if (animationTimeout) clearTimeout(animationTimeout);
			$('.dot').removeClass('visible');
			// $('.dot').each(function () {
			// 	if ($(this)[0]._tippy) {
			// 		$(this)[0]._tippy.hide();
			// 	}
			// });
			$('.route-group').removeClass('active');

			var $targetGroup = $('#' + routeId);
			var $targetPaths = $targetGroup.find('.path');
			var $targetDots = $targetGroup.find('.dot');

			$targetGroup.addClass('active');

			// --- GỌI HÀM ZOOM ---
			applyZoom($targetGroup, isZoom);

			// --- XỬ LÝ VẼ ĐƯỜNG (Giữ nguyên) ---
			var combinedPathData = "";
			$targetPaths.each(function () {
				combinedPathData += $(this).attr('d') + " ";
			});

			$maskPath.attr('d', combinedPathData);

			var length = $maskPath[0].getTotalLength();

			$maskPath.css({
				'transition': 'none',
				'stroke-dasharray': length,
				'stroke-dashoffset': length
			});

			$maskPath[0].getBoundingClientRect();

			var duration = 1000;
			$maskPath.css({
				'transition': 'stroke-dashoffset ' + duration + 'ms linear',
				'stroke-dashoffset': '0'
			});

			animationTimeout = setTimeout(function () {
				$targetDots.addClass('visible');
				$targetPaths.addClass('marching');
				// setTimeout(function () {
				// 	$targetDots.each(function (index, element) {
				// 		if (element._tippy) {
				// 			element._tippy.show();
				// 		}
				// 	});
				// }, duration * 1.5);
			}, duration);
		});

		// Start
		$btns.eq(currentAutoIndex).trigger('click', [true]);
		startLoop();



	});


});

